export default __webpack_public_path__ + "static/media/kick_short.95cd992a.mp3";